import { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Dialog, Transition } from "@headlessui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Button from "@components/Button";

const cardVariants = {
	hidden: { opacity: 0, y: 50 },
	visible: { opacity: 1, y: 0 },
};

function PackageCard({ title, price, description, priceId }) {
	const [isModalVisible, setIsModalVisible] = useState(false);
	// const [isHovered, setIsHovered] = useState(false);
	const navigate = useNavigate();

	const handlePurchase = () => {
		const packageData = { title, price, description, priceId };
		// Navigate to checkout with package data
		navigate("/checkout", { state: { packageData } });
	};

	return (
		<motion.div
			initial="hidden"
			animate="visible"
			variants={cardVariants}
			transition={{ duration: 1 }}
			className="flex flex-col justify-between items-center bg-white/60 backdrop-blur-md p-6 space-y-6 xl:lg:px-6 xl:lg:py-12 rounded-2xl xl:w-[25rem] xl:h-[35rem] lg:w-[25rem] lg:h-[30rem] group"
			// onMouseEnter={() => setIsHovered(true)}
			// onMouseLeave={() => setIsHovered(false)}
		>
			<div className="flex flex-col justify-start items-center w-full ">
				<div className="space-y-12 font-generalSans text-center text-steerBlack">
					<h2 className="font-semibold xl:lg:text-2xl text-lg cursor-default">
						{title}
					</h2>
					<p className="text-sm font-light cursor-default">{description}</p>
				</div>
			</div>

			<div className="flex flex-col justify-end items-center w-full space-y-4 bg-steerBg rounded-2xl p-6">
				<p className="font-semibold text-steerOrange text-4xl xl:lg:text-5xl cursor-default">
					${price}
					<span className="text-steerLightBlack dark:text-gray-200 text-base font-extralight">
						/ package
					</span>
				</p>

				<Button
					buttonName="book now"
					buttonStyle="secondary"
					onClick={handlePurchase}
				/>
			</div>

			<Transition appear show={isModalVisible} as={Fragment}>
				<Dialog
					as="div"
					className="relative z-50"
					open={isModalVisible}
					onClose={() => setIsModalVisible(false)}
				>
					{/* The backdrop, rendered as a fixed sibling to the panel container */}
					<div className="fixed inset-0 bg-black/30" aria-hidden="true" />

					{/* Full-screen container to center the panel */}
					<div className="fixed inset-0 flex justify-center items-center p-4">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
							<Dialog.Panel className="bg-steerLightBlack mx-auto p-12 rounded max-w-lg">
								<Dialog.Title
									as="h3"
									className="font-poppins font-semibold text-4xl text-center text-white"
								>
									Redirecting to Checkout...
								</Dialog.Title>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
		</motion.div>
	);
}

PackageCard.propTypes = {
	title: PropTypes.string.isRequired,
	price: PropTypes.number.isRequired,
	description: PropTypes.string.isRequired,
	priceId: PropTypes.string.isRequired,
};

export default PackageCard;
